export class Money {
    public static format(price: number, currency: string, endStripe: boolean = false): string {
        let currencySign = '€';
        if (currency === 'GBP') currencySign = '£';
        if (currency === 'USD') currencySign = '$';


        if (endStripe && price % 100 === 0) {
            return currencySign + Number(price / 100).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ',-';
        }

        return currencySign +
            (Number(price / 100)).toLocaleString(
                undefined,
                {minimumFractionDigits: 2, maximumFractionDigits: 2}
            );
    }
}
